import React from 'react';
import { bonuses } from '../data/content';
import { BonusCover } from './BonusCover';
import { SectionHeading } from './SectionHeading';

// 3 + 2 centered layout on desktop
const placement = ['', '', '', 'lg:col-start-2', ''];
export function Bonuses() {
  return <section aria-labelledby="bonuses-title" className="bg-cream" data-id="element-22" data-mp="at8uo6i86ra9">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-23" data-mp="fslgqp19vubs">
        <SectionHeading id="bonuses-title" title={<>
              Et vous recevrez aussi <span className="italic text-coral" data-id="element-25" data-mp="5wruuf1nyohc">5 bonus d’évangélisation</span>
            </>} intro="Des ressources créées pour vous aider à aller au-delà du simple partage d’un imprimable et à vivre le Grand Mandat avec davantage d’intention." data-id="element-24" data-mp="1u58uurobxs2" />
        <ol className="mx-auto mt-16 grid max-w-5xl grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-6" data-id="element-26" data-mp="1m9yvfa3vqqwh">
          {bonuses.map((b, i) => <li key={b.number} className={`flex flex-col lg:col-span-2 ${placement[i]}`} data-id="element-27" data-mp="1r78snbxig6uv" data-mpi={i}>
              <div className="relative mx-auto w-full max-w-[280px]" data-id="element-28" data-mp="3iclnrsv34kyc">
                <span className="absolute -left-3 -top-3 z-10 rounded-full bg-navy px-3 py-1.5 text-xs font-extrabold uppercase tracking-[0.1em] text-white shadow-card" data-id="element-29" data-mp="3deaepkcm6eh6">
                  Bonus n° {b.number}
                </span>
                <BonusCover bonus={b} data-id="element-30" data-mp="3n5y6xngzvzjp" />
              </div>
              <div className="mx-auto mt-6 flex max-w-[300px] flex-1 flex-col text-center" data-id="element-31" data-mp="2zeslmssacf20">
                <h3 className="font-display text-2xl leading-tight text-navy" data-id="element-32" data-mp="2uh967pjupw8h">{b.name}</h3>
                <p className="mt-3 font-bold leading-snug text-coral-deep" data-id="element-33" data-mp="38gs29jze1h4f">{b.lead}</p>
                <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-34" data-mp="33hfft0cfic2d">{b.body}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}